import { CSSProperties, FC, useMemo } from 'react';

import { useTheme } from '@mui/material';

import logo from 'assets/images/glm.svg';

interface LogoProps {
    isMinimalLogo?: boolean;
    sx?: CSSProperties;
}

const GLMLogo: FC<LogoProps> = (props) => {
    const { isMinimalLogo, sx } = props;
    const theme = useTheme();

    const themeLogo = useMemo(() => (theme.palette.mode === 'dark' ? logo : logo), [theme.palette.mode]);

    if (isMinimalLogo) return <img src={logo} alt="GLM Logo" width="45" style={sx} />;

    return <img src={themeLogo} alt="GLM Logo" width="100" style={sx} />;
};
export default GLMLogo;
